// Lightweight fallback for lazy-loaded routes (sub-100ms typical).
// Avoid full-screen splash here so route transitions don't flicker.
export default function RouteFallback() {
  return (
    <div data-testid="route-fallback" className="min-h-[60vh] flex items-center justify-center">
      <div className="flex items-center gap-2 text-zinc-400">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce-dot" style={{ animationDelay: "0ms" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce-dot" style={{ animationDelay: "150ms" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce-dot" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
}
